import React, { type ReactNode } from 'react';
import type { EntityName } from '../../../../auth/Security';
import { EntitySecurityProvider, FeatureSecurityProvider } from '../../../../auth/Security';
import type { SidePanelDeclaration, SidePanelSession } from '../../../types';

export function SidePanelSlot({
    session,
    Component,
    options
}: {
    session: SidePanelSession | null;
    Component: SidePanelDeclaration['definition']['Component'];
    options?: SidePanelDeclaration['options'];
}) {
    if (!session) {
        return null;
    }

    const subjectEntry = session.subject
        ? [{ entityName: session.subject.entityName, entitySecurity: session.subject.security }]
        : [];
    const entityChain = [...subjectEntry, ...session.entitySecurityChain];
    const content = <Component {...options} />;

    function provideEntityContext(index: number): ReactNode {
        const entry = entityChain[index];
        if (!entry) {
            return provideFeatureContext(session.featureSecurityChain.length - 1);
        }
        return (
            <EntitySecurityProvider entityName={entry.entityName as EntityName} entitySecurity={entry.entitySecurity}>
                {provideEntityContext(index - 1)}
            </EntitySecurityProvider>
        );
    }

    function provideFeatureContext(index: number): ReactNode {
        const featureName = session.featureSecurityChain[index];
        if (!featureName) {
            return content;
        }
        return (
            <FeatureSecurityProvider featureName={featureName}>
                {provideFeatureContext(index - 1)}
            </FeatureSecurityProvider>
        );
    }

    return <>{provideEntityContext(entityChain.length - 1)}</>;
}
